"use client";

import InfoCircleIcon from "@public/icons/info-circle-icon.svg";
import { type FC, useState } from "react";
import { MdClose } from "react-icons/md";

export const SignupAlertBanner: FC<{ message: string }> = ({ message }) => {
  const [visible, setVisible] = useState(true);

  if (!visible) {
    return null;
  }

  return (
    <div className="relative flex w-full items-center justify-center gap-3 bg-primary-5 px-10 py-4 text-sm font-bold text-white">
      <InfoCircleIcon className="h-5 w-5 shrink-0" />
      <p>{message}</p>
      <button
        type="button"
        onClick={() => setVisible(false)}
        aria-label="閉じる"
        className="absolute right-4"
      >
        <MdClose className="h-5 w-5" />
      </button>
    </div>
  );
};
